import { BRAND } from "../../data/mock";

export const Footer = () => {
  return (
    <footer className="border-t border-white/10 py-10" data-testid="footer">
      <div className="mx-auto flex max-w-6xl flex-col items-center gap-4 px-4 sm:flex-row sm:justify-between">
        <span className="flex items-center gap-2 font-heading text-sm text-white">
          <img src={BRAND.logoUrl} alt="Tap 4 Reviews logo" className="h-7 w-auto object-contain" />
          {BRAND.logoFirst}<span className="text-[#2f7fff]">{BRAND.logoAccent}</span>{BRAND.logoSecond}
        </span>
        <p className="text-xs text-zinc-500">
          © {new Date().getFullYear()} {BRAND.name}. All rights reserved.
        </p>
      </div>
    </footer>
  );
};
